/* Velvet Vogue - product page rows (UI). Needs vv-rows-engine.js (window.VVR). */
(function () {
  'use strict';
  var root = document.querySelector('[data-vrw]');
  if (!root || !window.VVR) return;
  var src;
  try { src = JSON.parse(root.querySelector('[data-vrw-src]').textContent); } catch (e) { root.hidden = true; return; }
  var box = root.querySelector('.vrw-rows');
  var feed = root.getAttribute('data-feed');
  var pv = new URLSearchParams(location.search).get('preview_theme_id');
  var KEY = 'vrw-feed-v2', FRESH = 20 * 60 * 1000, STALE = 24 * 3600 * 1000;

  function url(n) { return feed + n + (pv ? '&preview_theme_id=' + encodeURIComponent(pv) : ''); }
  function page(n) {
    return fetch(url(n), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw 0;
      return r.text();
    }).then(function (t) {
      var m = /<script[^>]*id="vv-feed"[^>]*>([\s\S]*?)<\/script>/.exec(t);
      if (!m) throw 0;
      return JSON.parse(m[1]);
    });
  }
  function fetchAll(guess) {
    var n = Math.max(guess || 0, 16), reqs = [], i;
    for (i = 1; i <= n; i++) reqs.push(page(i).catch(function () { return null; }));
    return Promise.all(reqs).then(function (res) {
      if (!res[0]) throw 0;
      var pages = res[0].pages, more = [];
      for (i = n + 1; i <= pages; i++) more.push(page(i));
      return Promise.all(more).then(function (m2) {
        var seen = {}, out = [];
        res.concat(m2).forEach(function (x) {
          if (x) x.d.forEach(function (r) { if (!seen[r[0]]) { seen[r[0]] = 1; out.push(window.VVR.slim(r)); } });
        });
        return { d: out, pages: pages };
      });
    });
  }
  function readCache() {
    try { var o = JSON.parse(localStorage.getItem(KEY)); if (o && o.d && o.d.length > 50 && Date.now() - o.t < STALE) return o; } catch (e) {}
    return null;
  }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), p: o.pages, d: o.d })); } catch (e) {} return o; }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(d) { var c = Math.round(d * 100); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100).replace(/\B(?=(\d{3})+$)/g, ',')); }
  function img(u, w) { return u.replace(/([?&])width=\d+/, '$1width=' + w); }
  var L = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3 5 8l5 5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  var R = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="m6 3 5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

  function card(p, i) {
    var sale = p.c > p.p && p.p > 0;
    return '<a class="vrw-card" href="/products/' + esc(p.h) + '"><span class="vrw-img">' +
      (p.i ? '<img alt="' + esc(p.t) + '" decoding="async" sizes="(min-width:1280px) 19vw,(min-width:990px) 22vw,(min-width:750px) 30vw,42vw" data-src="' + esc(img(p.i, 360)) + '" data-srcset="' +
        esc(img(p.i, 240) + ' 240w,' + img(p.i, 360) + ' 360w,' + img(p.i, 480) + ' 480w') + '">' : '') +
      (sale ? '<span class="vrw-badge">Sale</span>' : '') + '</span>' +
      '<span class="vrw-name">' + esc(p.t) + '</span><span class="vrw-price"><span class="vrw-now">' + money(p.p) + '</span>' +
      (sale ? '<s class="vrw-was">' + money(p.c) + '</s><span class="vrw-tags"><span class="vv-bf-tag">Black Friday</span><span class="vrw-save">Save ' + money(p.c - p.p) + '</span></span>' : '') + '</span></a>';
  }
  function rowHtml(r, k) {
    var n = r.items.length;
    return '<section class="vrw-row" data-k="' + r.key + '" aria-labelledby="vrw-h' + k + '"><div class="vrw-head"><div><h3 class="vrw-title" id="vrw-h' + k + '">' + esc(r.title) +
      '</h3><p class="vrw-sub">' + esc(r.sub) + '</p></div><div class="vrw-ctrl">' +
      '<span class="vrw-btns"><button type="button" class="vrw-btn" data-d="-1" aria-label="Scroll left">' + L + '</button><button type="button" class="vrw-btn" data-d="1" aria-label="Scroll right">' + R + '</button></span>' +
      '<span class="vrw-swipe">Swipe ' + R + '</span></div></div><div class="vrw-wrap is-start"><div class="vrw-scroller" tabindex="0" role="region" aria-label="' + esc(r.title) + '">' +
      r.items.map(card).join('') + '</div></div><div class="vrw-bar" aria-hidden="true"><i></i></div></section>';
  }

  function loadImg(c) {
    var im = c.querySelector('img');
    if (im && im.getAttribute('data-src')) { im.srcset = im.getAttribute('data-srcset'); im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); }
  }
  function arm(sc) {
    if (!('IntersectionObserver' in window)) { [].forEach.call(sc.children, loadImg); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); loadImg(e.target); } });
    }, { root: sc, rootMargin: '0px 700px' });
    [].forEach.call(sc.children, function (c) { io.observe(c); });
  }
  var rowIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { rowIO.unobserve(e.target); arm(e.target); } });
  }, { rootMargin: '600px 0px' }) : null;

  function wire(sec) {
    var sc = sec.querySelector('.vrw-scroller'), wrap = sec.querySelector('.vrw-wrap'), thumb = sec.querySelector('.vrw-bar i'),
      b = sec.querySelectorAll('.vrw-btn');
    function upd() {
      var max = sc.scrollWidth - sc.clientWidth, x = sc.scrollLeft, w = Math.max(8, sc.clientWidth / sc.scrollWidth * 100);
      wrap.classList.toggle('is-start', x < 4); wrap.classList.toggle('is-end', x > max - 4);
      b[0].disabled = x < 4; b[1].disabled = x > max - 4;
      thumb.style.width = w + '%';
      thumb.style.transform = 'translateX(' + (max > 0 ? x / max * (100 - w) / w * 100 : 0) + '%)';
    }
    sc.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    [].forEach.call(b, function (btn) {
      btn.addEventListener('click', function () { sc.scrollBy({ left: +btn.getAttribute('data-d') * sc.clientWidth * 0.85, behavior: 'smooth' }); });
    });
    upd();
    if (rowIO) rowIO.observe(sc); else arm(sc);
  }

  /* single row of look-alikes: same kind, same colours, same style (small differences), never best sellers */
  function shortName(t) {
    t = String(t || '').replace(/^\s*[A-Za-z\-']+\s*(\||–|—| - )\s*/, '').split(',')[0].replace(/\s+for (Women|Men)\b.*$/i, '').replace(/^(Women|Men)(’|')s\s+/i, '').replace(/\s+/g, ' ').trim();
    if (t.length > 42) { t = t.slice(0, 42); t = t.slice(0, t.lastIndexOf(' ') > 18 ? t.lastIndexOf(' ') : 42).replace(/[\s\-–|&]+$/, '') + '…'; }
    return t || 'this item';
  }
  function kindOf(s) {
    var t = s.tk, g = s.grp;
    if (g === 'bottom') return s.skirt ? 'skirts' : (t.has('jeans') ? 'jeans' : 'pants');
    if (g === 'dress' && (t.has('jumpsuit') || t.has('romper') || t.has('playsuit')) && !t.has('dress')) return 'jumpsuits';
    if (g === 'top') return t.has('hoodie') ? 'hoodies' : t.has('cardigan') ? 'cardigans' : (t.has('sweater') || t.has('jumper') || t.has('pullover')) ? 'sweaters' : 'tops';
    if (g === 'outer') return (t.has('blazer') && !t.has('coat')) ? 'blazers' : 'coats';
    return g;
  }
  function colorJ(a, b) {
    if (!a.size && !b.size) return 0.5;
    if (!a.size || !b.size) return 0.25;
    var i = 0, u = new Set();
    a.forEach(function (x) { u.add(x); if (b.has(x)) i++; });
    b.forEach(function (x) { u.add(x); });
    return u.size ? i / u.size : 0;
  }
  function bsim(a, b) { var s = 0; Object.keys(a).forEach(function (k) { s += Math.min(a[k], b[k] || 0); }); return s; }
  function priceFit(s, c) {
    if (s.p <= 0 || c.p <= 0) return 0;
    var r = c.p / s.p;
    return (r >= 0.6 && r <= 1.6) ? 0.6 : (r >= 0.4 && r <= 2.5) ? 0.2 : -0.3;
  }
  function buildSingle(srcRow, rows) {
    var V = window.VVR, all = rows.map(V.enrich), src = V.enrich(srcRow), df = {}, n = all.length;
    all.forEach(function (p) { p.dt.forEach(function (t) { df[t] = (df[t] || 0) + 1; }); });
    var def = Math.log(n + 1) + 0.2;
    function idf(t) { var d = df[t]; return d === undefined ? def : Math.log((n + 1) / (d + 1)) + 0.2; }
    function wjac(a, b) {
      var i = 0, u = 0;
      a.forEach(function (t) { var w = idf(t); u += w; if (b.has(t)) i += w; });
      b.forEach(function (t) { if (!a.has(t)) u += idf(t); });
      return u ? i / u : 0;
    }
    var kind = kindOf(src), name = shortName(src.t);
    function ok(c) {
      if (c.bad || c.best || c.f.indexOf('s') >= 0 || c.h === src.h || c.grp !== src.grp) return false;
      if (src.gen === 'm' ? !(c.gen === 'm' || c.gen === 'u') : !(c.gen === 'w' || c.gen === 'u')) return false;
      return !kind || kindOf(c) === kind;
    }
    var scored = all.filter(ok).map(function (c) {
      var sc = 6 * wjac(src.dt, c.dt) + 2 * bsim(src.sv, c.sv) + 3 * colorJ(src.fam, c.fam) + 0.8 * priceFit(src, c) + (src.y && src.y === c.y ? 0.8 : 0);
      return { c: c, s: sc, same: !src.fam.size || colorJ(src.fam, c.fam) > 0 };
    });
    scored.sort(function (a, b) { return (b.s - a.s) || (a.c.h < b.c.h ? -1 : 1); });
    var picks = [], i, x;
    function dup(c) {
      if (wjac(c.dt, src.dt) >= 0.84) return true;
      for (var k = 0; k < picks.length; k++) if (wjac(c.dt, picks[k].dt) >= 0.84) return true;
      return false;
    }
    for (i = 0; i < scored.length && picks.length < 16; i++) { x = scored[i]; if (x.same && !dup(x.c)) picks.push(x.c); }
    for (i = 0; i < scored.length && picks.length < 6; i++) { x = scored[i]; if (!x.same && !dup(x.c)) picks.push(x.c); }
    return { rows: picks.length >= 3 ? [{ key: 'similar', title: 'You may also like', sub: 'Same style and colours as the ' + name + ', with small differences in the details.', items: picks }] : [] };
  }

  function render(data) {
    var res = buildSingle(src, data.d);
    if (!res.rows.length) { root.hidden = true; return; }
    box.innerHTML = res.rows.map(rowHtml).join('');
    root.classList.add('is-ready');
    [].forEach.call(box.querySelectorAll('.vrw-row'), wire);
  }
  var started = false;
  function start() {
    if (started) return; started = true;
    var c = readCache();
    if (c) {
      try { render(c); } catch (e) { root.hidden = true; }
      if (Date.now() - c.t > FRESH) fetchAll(c.p).then(save).catch(function () {});
      return;
    }
    fetchAll(0).then(save).then(render).catch(function () { root.hidden = true; });
  }
  function check() {
    if (started) return;
    if (root.getBoundingClientRect().top < window.innerHeight + 1500) {
      document.removeEventListener('scroll', check, true); window.removeEventListener('resize', check);
      start();
    }
  }
  if (readCache()) start();
  else {
    document.addEventListener('scroll', check, { capture: true, passive: true });
    window.addEventListener('resize', check);
    check();
  }
})();